import * as React from 'react'
import BaseIcon from 'react-icon-base'

const StoriesEmptyIcon = props => (
  <BaseIcon width="200" height="200" viewBox="0 0 200 200" {...props}>
    <path
      fill="#E9ECF0"
      fillRule="evenodd"
      d="M100 200C44.772 200 0 155.228 0 100S44.772 0 100 0s100 44.772 100 100-44.772 100-100 100zm36-64c6.627 0 12-5.373 12-12V76c0-6.627-5.373-12-12-12H64c-6.627 0-12 5.373-12 12v48c0 6.627 5.373 12 12 12h48l24 24v-24zm-60-30h48v6H76v-6zm0-18h48v6H76v-6z"
    />
  </BaseIcon>
)

export default StoriesEmptyIcon
